/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Inject} from '@angular/core';
import template from './team-group-list-page.component.html';

import {AdminListColumn, AdminResourceListPageBase} from '../../common/controller/admin-resource-list-page-base';
import {LocalNetworkProfile} from '../../../components/session/local-network-profile';

@Component({
  standalone: false,
  selector: 'adn-team-group-list-page',
  template
})
export class TeamGroupListPageComponent extends AdminResourceListPageBase {
  readonly itemStateName = 'app.adm.team-groups.team-group';

  columns: AdminListColumn[] = [
    {param: 'name'},
    {param: 'description'},
    {param: 'type'}
  ];

  constructor(
    @Inject(LocalNetworkProfile) LocalNetworkProfile: any
  ) {
    super(LocalNetworkProfile);
  }

}
